import React from 'react';
import Tab from '@material-ui/core/Tab';
import { Box, Paper, withStyles } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

export const StyledTab = withStyles({
  root: {
    minWidth: 0,
  },
})((props) => <Tab disableRipple {...props} />);

export const StyledForm = withStyles({
  root: {
    display: 'flex',
    flexDirection: isMobile ? 'column' : 'row',
    padding: '1rem',
    gap: '2rem',
    width: '100%',
  },
})((props) => <Box {...props} />);

export const StyledContainer = withStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    padding: isMobile ? '0.25rem' : '2rem',
  },
})((props) => <Box {...props} />);

export const StyledSchedulePaper = withStyles({
  root: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: isMobile ? 'row' : 'column',
  },
})((props) => (
  <Paper square>
    <Box {...props} />
  </Paper>
));
